// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ClassTooltipContent_wrapper__2Lx3X {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  margin-right: 20px; }\n  .ClassTooltipContent_wrapper__2Lx3X .ClassTooltipContent_content__1RaXP {\n    color: #40586f;\n    display: flex;\n    flex-direction: column;\n    min-width: 100%; }\n    .ClassTooltipContent_wrapper__2Lx3X .ClassTooltipContent_content__1RaXP b {\n      font-weight: 600;\n      line-height: 22px; }\n  .ClassTooltipContent_wrapper__2Lx3X .anticon {\n    margin-right: 9px;\n    color: #faad14; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ClassTooltipContent_wrapper__2Lx3X",
	"content": "ClassTooltipContent_content__1RaXP"
};
module.exports = exports;
